import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OEMCompany, OEMFilterData, OEMTableData, OemDetails } from 'src/app/models/oem-models';
import { FilterPayload } from 'src/app/models/product-model';
import { ApiResponseModel } from 'src/app/models/shared-model';
import { apiUrls, OEMUrls } from 'src/app/utils/apiUrls';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OemManagementService {

  OemUrl = OEMUrls.oem;
  constructor(private http: HttpClient,private datePipe: DatePipe, ) { }

  oemSummery(data: any){
    return this.http.post<ApiResponseModel<OEMFilterData>>(`${this.OemUrl}/summary`, data)
  }
  oemSummeryWithSearchKeyword(data: any, searchKeyword: any){
    return this.http.post<ApiResponseModel<OEMFilterData>>(`${this.OemUrl}/summary-with-search-keyword?searchKeyword=${searchKeyword}`, data)
  }

  getAllOEMsData(page: number, size: number, body: any): Observable<ApiResponseModel<OEMTableData[]>> {
    const formattedBody = {
      ...body,
      startDate: this.datePipe.transform(body.startDate, 'yyyy-MM-dd\'T\'HH:mm:ss.SSSZ'),
      endDate: this.datePipe.transform(body.endDate, 'yyyy-MM-dd\'T\'HH:mm:ss.SSSZ'),
    };
    return this.http.post<ApiResponseModel<OEMTableData[]>>(`${this.OemUrl}/all?page=${page}&size=${size}`, formattedBody);
  }

  getAllOEMsDataWithSearchKeyword(page: number, size: number, searchKeyword: any, body: any): Observable<ApiResponseModel<OEMTableData[]>> {
    const formattedBody = {
      ...body,
      startDate: this.datePipe.transform(body.startDate, 'yyyy-MM-dd\'T\'HH:mm:ss.SSSZ'),
      endDate: this.datePipe.transform(body.endDate, 'yyyy-MM-dd\'T\'HH:mm:ss.SSSZ'),
    };
    return this.http.post<ApiResponseModel<OEMTableData[]>>(`${this.OemUrl}/all?page=${page}&size=${size}&searchKeyword=${searchKeyword}`, formattedBody);
  }

  getOemDataById(id: string): Observable<ApiResponseModel<OemDetails>> {
    return this.http.get<ApiResponseModel<OemDetails>>(`${this.OemUrl}/get-oem-with-management?id=${id}`);
  }

  deleteOem(id: string): Observable<ApiResponseModel<string>> {
    return this.http.delete<ApiResponseModel<string>>(`${this.OemUrl}/${id}`);
  }

  addOEM(data: OemDetails): Observable<ApiResponseModel<string>> {
    data.companyInformation.email = data.companyInformation.email.toLowerCase();
    return this.http.post<ApiResponseModel<string>>(`${this.OemUrl}/add-with-management`, data);
  }

  checkCompanyName(companyName: string): Observable<ApiResponseModel<string>> {
    const params = new HttpParams().set('name', companyName);
    return this.http.get<ApiResponseModel<string>>(`${this.OemUrl}/check-company-name`, { params });
  }

  updateOEM(data: OemDetails): Observable<ApiResponseModel<string>> {
    return this.http.put<ApiResponseModel<string>>(`${this.OemUrl}/update-with-management`, data);
  }

  deleteFinancialInfoById(id: string): Observable<ApiResponseModel<string>> {
    return this.http.delete<ApiResponseModel<string>>(`${this.OemUrl}/financial-information/delete/${id}`);
  }
  searchOEM (keyword: string): Observable<ApiResponseModel<OEMTableData[]>> {
    return this.http.get<ApiResponseModel<OEMTableData[]>>(`${this.OemUrl}/search?keyword=${keyword}`);
  }

  getCreatedBy(): Observable<ApiResponseModel<OEMTableData[]>> {
    return this.http.get<ApiResponseModel<OEMTableData[]>>(`${this.OemUrl}/createdby`);
  }

  checkPhoneNumber(phoneNumber: string): Observable<ApiResponseModel<string>> {
    return this.http.get<ApiResponseModel<string>>(`${this.OemUrl}/check-phone-number?phoneNumber=${phoneNumber}`);
  }
}
